








import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<NPSBarLabel>({})
export default class NPSBarLabel extends Vue {
    @Prop({ type: Number, required: true }) public min!: number
    @Prop({ type: Number, required: true }) public max!: number
    @Prop({ type: Number, required: true }) public average!: number

    public get range(): number {
        return this.max - this.min
    }

    public get middleRelative() {
        return this.average - this.min
    }

    public get middlePercent(): number {
        const value = this.range > 0 ? this.middleRelative / this.range * 100 : 50
        // min value limited to 5, because when value is 0, we don't need to center the label
        // instead left align it
        return Math.max(5, Math.min(100, value))
    }
}
